/**
 * GENERATED by tools/outlaw-generator/src/generator/client_redux.rs from each schema's includeDeletedInResults. Do not edit.
 *
 * Entity types that keep their deleted rows (status 'D') in full fetches, in the Redux collection and in
 * the offline backup. Every other type keeps only the deletion version of a removed row (OWA-68).
 */
export const RETAINED_DELETED_TYPES: readonly string[] = Object.freeze(['activityCategory', 'activityType', 'contact', 'templateTask', 'transaction', 'user']);
